const secretKey = 'toab-bttf-2025';

export function encodeData(data: any) {
  // Convert data to JSON
  const jsonData = JSON.stringify(data);

  // Base64 encode with URI-safe transformation
  const base64Data = window.btoa(encodeURIComponent(jsonData));

  // Append secret key and encode the combined string
  const combinedData = `${base64Data}${secretKey}`;
  return window.btoa(encodeURIComponent(combinedData));
}

export function decodeData(encodedData: string) {
  // Decode the encoded data to get the combined string
  const combinedData = decodeURIComponent(window.atob(encodedData));

  // Validate and extract the Base64-encoded data (ensure it ends with the secret key)
  if (!combinedData?.endsWith(secretKey)) {
    throw new Error('Invalid secret key or corrupted data');
  }

  // Remove the secret key
  const base64Data = combinedData.slice(0, -secretKey.length);

  // Decode the Base64 data to get the JSON string
  const jsonDataEncoded = decodeURIComponent(window.atob(base64Data));

  // Parse the JSON string
  return JSON.parse(jsonDataEncoded);
}
